import api from "api";

const PATH = "/CadastroUsuario";
const qs = require("qs");

const POST_USUARIO = async (usuario) => {
  try {
    const { data } = await api.post(`${PATH}/cadastrar`, usuario);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const POST_USUARIO_UPDATE = async (usuario) => {
  try {
    const { data } = await api.post(`${PATH}/atualizar`, usuario);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const POST_NOVA_SENHA = async (bodyData) => {
  const { data } = await api.post(`${PATH}/post-nova-senha`, bodyData);
  return data;
};
const POST_RECUPERAR_SENHA = async (bodyData) => {
  const { data } = await api.post(`${PATH}/post-recuperar-senha`, bodyData);
  return data;
};

const GET_LIST_USUARIO = async (filtros) => {
  try {
    const { data } = await api.get(`${PATH}/get-list-paged`, {
      params: filtros,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
export {
  GET_LIST_USUARIO,
  POST_USUARIO,
  POST_USUARIO_UPDATE,
  POST_NOVA_SENHA,
  POST_RECUPERAR_SENHA,
};
